var exports = {
  "s": "jumpWiggle__1Ljq59",
  "K": "copilotRun__Qpowap",
};

module.exports = exports;
